import { SOLD_SERVICE_STATUS } from '@sales-center/common'
import { useAppSelector } from '@user/store/hooks'
import {
  selectCurrentUser,
  useCheckPermissions,
} from '@user/store/authorization'
import { useCwqClosedLostEnabled } from './useCwqClosedLostEnabled'

export function useCwqAdminClosedLost(
  soldServiceStatus: SOLD_SERVICE_STATUS,
): boolean {
  const enabled = useCwqClosedLostEnabled(soldServiceStatus)
  const { isAdmin } = useAppSelector(selectCurrentUser)

  const [canCloseLostOpp] = useCheckPermissions(
    'opportunities_cancel_closed/lost_services',
  )

  return enabled && (isAdmin || canCloseLostOpp)
}
